/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Shy_Owl_PeekInputs */

const en_warm_shy_owl_peek = /** @type {(inputs: Warm_Shy_Owl_PeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data source`)
};

const de_warm_shy_owl_peek = /** @type {(inputs: Warm_Shy_Owl_PeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Datenquelle`)
};

/**
* | output |
* | --- |
* | "No data source" |
*
* @param {Warm_Shy_Owl_PeekInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_shy_owl_peek = /** @type {((inputs?: Warm_Shy_Owl_PeekInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Shy_Owl_PeekInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_shy_owl_peek(inputs)
	return de_warm_shy_owl_peek(inputs)
});